import { MenuItem, Select, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringFilter() {
    const { filter, setFilter, filterOptions = [] } = useBoundContext()

    return (
        <Stack direction={"row"} alignItems={"center"} ml={6} justifyContent={"right"} flex={"0.25"}>
            <Select
                value={filter || ""}
                onChange={handleChange}
                size="small"
                variant="standard"
                disableUnderline
                displayEmpty
                data-cy="authoring-filter-select"
                IconComponent={() => null}
                sx={{
                    "& .MuiSelect-select": {
                        paddingBottom: 0,
                    },
                }}
                renderValue={(selected) => (
                    <Stack direction="row" alignItems="center" gap="10px">
                        <Typography fontWeight="bold">Status:</Typography>
                        <Typography fontWeight={100}>{selected ? selected.titleize?.() ?? selected : "All"}</Typography>
                        <Iconify sx={{ width: 22, height: 22 }} icon="mdi:chevron-down" />
                    </Stack>
                )}
            >
                <MenuItem value="" data-cy="authoring-filter-option-all">
                    <Typography fontWeight={100}>All</Typography>
                </MenuItem>
                {filterOptions.map((type, i) => (
                    <MenuItem key={filterOptions[i]} value={filterOptions[i]}>
                        <Typography data-cy={`authoring-filter-option-${type}`} fontWeight={100}>
                            {type.titleize()}
                        </Typography>
                    </MenuItem>
                ))}
            </Select>
        </Stack>
    )

    function handleChange({ target }) {
        setFilter(target.value)
    }
}
